// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1-7j3","vLegacy":"SelectSecondary_vLegacy__1Wiun","error":"SelectSecondary_error__3GTAc","disabled":"SelectSecondary_disabled__1m4gM"};